/*
 * Copyright © 2018, Rezo Zero
 *
 * @file MobileModal.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 */

import $ from 'jquery'
import EventEmitter from '../utils/EventEmitter'
import { TweenLite } from 'gsap'

export default class MobileModal extends EventEmitter {
    constructor () {
        super()

        // Elements
        this.$body = $('body').eq(0)

        /**
         * @type {jQuery|HTMLElement}
         */
        this.$tpl = $('<div class="launch-overlay"><button id="launch-btn" class="launch-btn"></button></div>')

        /**
         * @type {jQuery|HTMLElement}
         */
        this.$launchBtn = this.$tpl.find('#launch-btn')

        // Bind methods
        this.launch = this.launch.bind(this)
    }

    init () {
        // Add template
        this.$body.append(this.$tpl)

        // Init events
        this.$launchBtn.on('click', this.launch)

        // Show template
        this.show()
    }

    show () {
        TweenLite.to(this.$tpl, 0.5, {
            alpha: 1
        })
    }

    hide () {
        TweenLite.to(this.$tpl, 0.55, {
            alpha: 0,
            onComplete: () => {
                this.destroy()
            }
        })
    }

    destroy () {
        this.$tpl.remove()
    }

    launch () {
        this.hide()
        this.dispatchEvent('launch')
    }
}



// WEBPACK FOOTER //
// ./webpack/js/common/MobileModal.js